import { ImportJobState } from "api/features/import/ops";

export type ImportJobDisplayStatus = "idle" | "running" | "success" | "failed" | "warning";

export function getImportJobTotalRejected(job?: ImportJobState): number {
  return job?.steps.reduce((sum, step) => sum + step.rejectedCount, 0) ?? 0;
}

export function getImportJobDisplayStatus(
  job?: ImportJobState,
  totalRejected = getImportJobTotalRejected(job)
): ImportJobDisplayStatus {
  if (!job) return "idle";

  if (totalRejected >= 1) {
    if (job.status === "running" || job.status === "queued") return "warning";
    return "failed";
  }

  if (job.status === "success") return "success";
  if (job.status === "failed") return "failed";
  if (job.status === "running" || job.status === "queued") return "running";

  return "idle";
}

export function isImportJobDisplaySuccess(
  job?: ImportJobState,
  totalRejected = getImportJobTotalRejected(job)
): boolean {
  return getImportJobDisplayStatus(job, totalRejected) === "success";
}

export function isImportJobDisplayFailed(
  job?: ImportJobState,
  totalRejected = getImportJobTotalRejected(job)
): boolean {
  return getImportJobDisplayStatus(job, totalRejected) === "failed";
}

export function getImportStepProgressColor(
  step: ImportJobState["steps"][number],
  options: { isTimeoutFailure: boolean }
): "error" | "success" | "info" | "warning" {
  if (options.isTimeoutFailure || step.status === "failed") return "error";
  if (step.rejectedCount > 0) return "warning";
  if (step.status === "success") return "success";
  return "info";
}

export function mapDisplayStatusToProgressColor(
  displayStatus: ImportJobDisplayStatus
): "error" | "success" | "info" | "warning" {
  if (displayStatus === "failed") return "error";
  if (displayStatus === "success") return "success";
  if (displayStatus === "warning") return "warning";
  return "info";
}
